import { createSelector } from 'reselect';
import { urls } from "../Reducers/layout";
import { paramsToQueryString } from "../../Helpers/url";
import { EVALUATION_STATES, REPEAT_USER_COOKIE_NAME, SELLER_STATE_COOKIE, USER_INTENT, TAB_NAME, USER_VISIT_STATUS_LAYOUT, USER_INTENT_COOKIE } from "../../Constants/evaluation";
import { getChannelOfAcquisition, isPaidCampaign, getSessionShowAllTabs } from "../../Helpers/campaign";
import { REQUEST_ORIGINS, REQUEST_ORIGIN } from "../../Constants/requestOrigins";
import { TRACKING_ORIGINS } from "../../Constants/trackingEvents";
import SessionStorageHelper from "../../Utils/SessionStorageHelper";
import { removeParam } from "../../Utils/UrlHelpers";
import { LAYOUT_SOURCE } from "../../Constants/layoutSource";
import { CAMPAIGN_TYPE } from "../../Constants/campaign";
import { UNKNOWN } from "../../Constants/locations";
import { getSeoInformation } from "../../Helpers/seo";
var getUserContext = function getUserContext(cookies, tabName, layoutSource, location, buyerEvalState, isTabNotNameReq) {
  var sellerStateCookie = cookies && cookies.get(SELLER_STATE_COOKIE);
  var userIntentCookie = cookies && cookies.get(USER_INTENT_COOKIE);
  var userContext = {};
  if (layoutSource === LAYOUT_SOURCE.BUYER_INTENT) {
    userContext[USER_INTENT.BUYER] = buyerEvalState || EVALUATION_STATES.INITIAL;
  } else if (tabName === TAB_NAME.BUY) {
    userContext[USER_INTENT.BUYER] = EVALUATION_STATES.INITIAL;
    userContext.tabName = tabName;
  } else if (tabName === TAB_NAME.FINANCE) {
    userContext[USER_INTENT.FINANCE] = EVALUATION_STATES.INITIAL;
    userContext.tabName = tabName;
  } else {
    if (userIntentCookie) {
      if (sellerStateCookie) {
        userContext[USER_INTENT.SELLER] = sellerStateCookie;
      } else {
        if (userIntentCookie === USER_INTENT.BUYER) {
          userContext[USER_INTENT.BUYER] = EVALUATION_STATES.INITIAL;
        } else {
          userContext[USER_INTENT.SELLER] = sellerStateCookie || EVALUATION_STATES.INITIAL;
        }
      }
    } else {
      userContext[USER_INTENT.SELLER] = sellerStateCookie || EVALUATION_STATES.INITIAL;
    }
    if (tabName && !isTabNotNameReq) {
      userContext.tabName = tabName;
    }
  }
  if (layoutSource === LAYOUT_SOURCE.VALUATION_FLOW && userContext.tabName || layoutSource === LAYOUT_SOURCE.OLX || getSessionShowAllTabs(location)) {
    delete userContext.tabName;
  }
  return userContext;
};
var getLayoutAndSelectionURL = createSelector(function (state) {
  return state.cxeLayout;
}, function (_, _ref) {
  var location = _ref.location,
    marketConfig = _ref.marketConfig;
  return getChannelOfAcquisition(location.query, marketConfig === null || marketConfig === void 0 ? void 0 : marketConfig.get());
}, function (_, _ref2) {
  var locationId = _ref2.locationId;
  return locationId;
}, function (_, _ref3) {
  var layoutSource = _ref3.layoutSource;
  return layoutSource;
}, function (_, _ref4) {
  var lang = _ref4.lang;
  return lang;
}, function (state, _ref5) {
  var cookies = _ref5.cookies,
    layoutSource = _ref5.layoutSource,
    location = _ref5.location,
    marketConfig = _ref5.marketConfig;
  var tabName = state.cxeLayout.tabName;
  var buyerEvalState = state.buyerIntent.evaluationState;
  var isTabNotNameReq = marketConfig.get('olxAutos', 'tabViewNOTRequired');
  return JSON.stringify(getUserContext(cookies, tabName, layoutSource, location, buyerEvalState, isTabNotNameReq));
}, function (_, _ref6) {
  var cookies = _ref6.cookies;
  return cookies && cookies.get(REPEAT_USER_COOKIE_NAME) ? USER_VISIT_STATUS_LAYOUT.REPEAT : USER_VISIT_STATUS_LAYOUT.FIRST_TIME;
}, function (_, _ref7) {
  var viaBFF = _ref7.viaBFF;
  return viaBFF;
}, function (state) {
  return state.buyerIntent && state.buyerIntent.filters || {};
}, function (_, _ref8) {
  var params = _ref8.params,
    marketConfig = _ref8.marketConfig;
  return getSeoInformation(params, marketConfig === null || marketConfig === void 0 ? void 0 : marketConfig.get());
}, function (cxeLayout, channelOfAcquisition, locationId, layoutSource, lang, userContext, userVisit) {
  var viaBFF = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;
  var buyerIntentFilters = arguments.length > 8 ? arguments[8] : undefined;
  var seoInformation = arguments.length > 9 ? arguments[9] : undefined;
  var isPaidCampaign = channelOfAcquisition && channelOfAcquisition.type === CAMPAIGN_TYPE.PAID || false;
  var channelOfAcquisitionExtended = seoInformation ? Object.assign(Object.assign({}, channelOfAcquisition), {
    seoInformation: seoInformation.seoInfo
  }) : channelOfAcquisition;
  var additionalData = {};
  if (seoInformation && seoInformation.additionalData) {
    additionalData = seoInformation.additionalData;
  } else {
    additionalData = Object.assign(Object.assign({}, buyerIntentFilters), {
      locationId: locationId
    });
  }
  var queryParams = {
    locationId: isPaidCampaign ? UNKNOWN : locationId,
    userContext: userContext,
    userVisit: userVisit,
    channelOfAcquisition: channelOfAcquisitionExtended,
    requestOrigin: layoutSource === 'olxAutos' ? SessionStorageHelper.getItem(REQUEST_ORIGIN) || '' : '',
    lang: lang,
    additionalData: JSON.stringify(additionalData)
  };
  var baseUrl = viaBFF ? urls.getLayoutViaBFF(layoutSource) : urls.getLayout(layoutSource);
  var url = "".concat(baseUrl, "?").concat(paramsToQueryString(queryParams));
  url = removeParam('userVisit', url);
  return {
    cxeLayout: cxeLayout,
    url: url
  };
});
export var getLayoutSelector = createSelector(getLayoutAndSelectionURL, function (_ref9) {
  var cxeLayout = _ref9.cxeLayout,
    url = _ref9.url;
  return cxeLayout && cxeLayout.layouts && cxeLayout.layouts[url];
});
export var isError = createSelector(getLayoutAndSelectionURL, function (_ref10) {
  var cxeLayout = _ref10.cxeLayout,
    url = _ref10.url;
  return cxeLayout && cxeLayout.isError && cxeLayout.isError[url];
});
export var isFetching = createSelector(getLayoutAndSelectionURL, function (_ref11) {
  var cxeLayout = _ref11.cxeLayout,
    url = _ref11.url;
  return cxeLayout && cxeLayout.isFetching && cxeLayout.isFetching[url];
});
export var getTrackingOrigin = createSelector(function (_, location) {
  return location && location.query;
}, function (state) {
  return state.track.origin;
}, function (_, __, config) {
  return config;
}, function (query, origin, config) {
  var isMXCL = false;
  if (query && isPaidCampaign(query, config === null || config === void 0 ? void 0 : config.get()) && config) {
    return TRACKING_ORIGINS.PAID_DIRECT;
  }
  if (config) {
    isMXCL = !!config.get('olxAutos', 'isMXCL');
  }
  if (!isMXCL) {
    var requestOrigin = SessionStorageHelper.getItem(REQUEST_ORIGIN);
    if (requestOrigin === REQUEST_ORIGINS.HOME_PAGE) {
      return TRACKING_ORIGINS.HOME;
    }
    if (requestOrigin === REQUEST_ORIGINS.LISTING_PAGE) {
      return TRACKING_ORIGINS.LISTING_LOAD;
    }
    if (requestOrigin === REQUEST_ORIGINS.SELL_FLOW) {
      return TRACKING_ORIGINS.POSTING;
    }
    if (requestOrigin === REQUEST_ORIGINS.EVALUATION_FORM) {
      return origin === 'home' ? TRACKING_ORIGINS.HOME : origin;
    }
  }
  return TRACKING_ORIGINS.ORGANIC_DIRECT;
});
export default {
  getLayoutSelector: getLayoutSelector,
  isError: isError,
  isFetching: isFetching,
  getTrackingOrigin: getTrackingOrigin
};